module.exports = __webpack_public_path__ + "img/floor_2.1d26549a.png";